import { atom } from "recoil";

export const popupAtom = atom({
  key: "popup-atom",
  default: null,
});
